<template>
  <section class="documents">
    <div class="container">
      <v-app>
        <div class="mt-4">
          <div class="text-h3">Manutenção da Tela de Login</div>
          <v-divider class="mt-1 mb-4" />
          <div class="pa-5">
            Rotina de manutenção de imagem de fundo (Background) da tela de Login e Recuperação de senha:
            <br><br>
            <ul>
              <li>Para incluir uma nova imagem clique no campo de "Imagem" e selecione a imagem de deseja realizar o upload</li>
              <li>Após selecionar a imagem clique no botão "Incluir Imagem", após confirmação ela será enviada para o servidor</li>
              <li>A imagem ativa no momento é listada com o seguinte icone: <v-icon color="green">mdi-check-circle</v-icon></li>
              <li>Para ativar uma imagem clique sobre o icone: <v-icon>mdi-check-circle</v-icon></li>
              <ul>
                <li>Ao ativar um background automaticamente o que está ativo no momento será desativado</li>
              </ul>
              <li>Para deletar uma imagem clique sobre o icone: <v-icon color="red">mdi-delete</v-icon></li>
              <ul>
                <li>Não é possivel realizar a exclusão do background ativo</li>
              </ul>
            </ul>
          </div>
          <v-divider class="mt-1 mb-4" />
        </div>


        <div>
          <div class="text-h6">Upload de Imagem</div>
          <v-row>
            <v-col cols="4">
              <v-file-input
                accept="image/*"
                color="#005a64"
                v-model="imageToUpload"
                label="Imagem"
                outlined
                dense
              ></v-file-input>
            </v-col>
            <v-col class="text-left">
              <v-btn dark color="primary" @click="handleUploadImage()">
                Incluir imagem
              </v-btn>
            </v-col>
          </v-row>
        </div>

        <v-container fluid>
          <v-row dense>
            <v-col
              v-for="(card, index) in cards"
              :key="index"
              cols="6"
              class="d-flex child-flex flex-wrap justify-space-around flex-grow-1 flex-shrink-0"
              style="min-width: 200px; max-width: 100%;"
            >
              <v-card elevation="6">
                <v-img
                  :src="card.IMAGE"
                  class="grey lighten-2"
                  aspect-ratio="2"
                  gradient="to bottom, rgba(0,0,0,.1), rgba(0,0,0,.5)"
                  :lazy-src="card.IMAGE"
                >
                </v-img>

                <v-card-actions>
                  <v-spacer></v-spacer>

                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        icon
                        :color="card.ACTIVE === 'S' ? 'green' : 'grey'"
                        v-bind="attrs"
                        v-on="on"
                        @click="card.ACTIVE !== 'S' ? handleActiveBackground(card.ID) : true">
                        <v-icon>mdi-check-circle</v-icon>
                      </v-btn>
                    </template>
                    <span>{{card.ACTIVE === 'S' ? 'Imagem ativa' : 'Ativar imagem'}}</span>
                  </v-tooltip>

                  <v-tooltip bottom v-if="card.ACTIVE !== 'S'">
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        icon
                        color="red"
                        v-bind="attrs"
                        v-on="on"
                        @click="handleDeleteBackground(card.ID)">
                        <v-icon>mdi-delete</v-icon>
                      </v-btn>
                    </template>
                    <span>Deletar imagem</span>
                  </v-tooltip>

                </v-card-actions>
              </v-card>
            </v-col>
          </v-row>
        </v-container>
        <!-- Dialogs -->
        <!-- Confirm -->
        <v-dialog v-model="confirm.active" persistent width="400">
          <v-card>
            <v-card-title class="text-h5" style="background: #005a64; color: white;" v-html="confirm.title"></v-card-title>
            <div class="pa-7" v-html="confirm.message"></div>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="#005a64" text @click="confirm.active = false">CANCELAR</v-btn>
              <v-btn color="#005a64" text @click="confirm.action">SIM</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <!-- Loading -->
        <v-dialog v-model="loading.active" persistent width="300">
          <v-card color="var(--standardGreen)" dark>
            <v-card-text style="padding: 27px">
              <div v-html="loading.message"></div>
              <v-progress-linear
                style="margin-top: 15px"
                indeterminate
                color="white"
                class="mb-0"
              ></v-progress-linear>
            </v-card-text>
          </v-card>
        </v-dialog>
        <!-- Success -->
        <v-dialog v-model="successError.active" persistent width="400">
          <v-card>
            <v-card-title class="text-h5" style="background: #005a64; color: white;" v-html="successError.title"></v-card-title>
            <div class="pa-7" v-html="successError.message"></div>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="#005a64" text @click="successError.action">OK</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-app>
    </div>
  </section>
</template>

<script>
import axios from 'axios';

export default {
  data() {
    return {
      token: null,
      confirm: {
        title: null,
        active: false,
        message: null,
        action: null
      },
      successError: {
        title: null,
        active: false,
        message: null,
        action: null
      },
      loading: {
        active: false,
        message: null
      },
      cards: [],
      imageToUpload: null,
    };
  },

  created() {
     // Recupera o token do usuário logado
    let dados = JSON.parse(localStorage.getItem("login"));
    this.token = dados.token;

    this.loading.message = "Buscando dados! Aguarde...";
    this.loading.active = true;
    axios.get(
      `https://www.leverosintegra.com.br/map/Api/SolarBanners?token=${this.token}&background=true`
    ).then(res => {
      if (res && res.status === 200) {
        this.cards = res.data
      }
      this.loading.active = false;
    }).catch(err => {
      if (err && err.response && err.response.status === 401) {
        window.location = '/login';
        return;
      } else {
        this.loading.active = false;
        this.successError.title = "Ops...";
        this.successError.message = "Erro ao salvar background!<br/>" + err;
        this.successError.action = () => { window.location.reload() }
        this.successError.active = true;
      }
    })
  },

  methods: {
    handleUploadImage() {
      if (this.imageToUpload) {
        this.confirm.title = "Atenção!";
        this.confirm.message = "Deseja prosseguir com o upload da Imagem?<br/>A imagem será salva no servidor.";
        this.confirm.action = () => { this.uploadImage() }
        this.confirm.active = true;
      }
    },

    uploadImage() {
      this.confirm.active = false;
      let that = this;

      var reader = new FileReader();
      reader.readAsDataURL(this.imageToUpload);
      reader.onload = function () {
        that.loading.message = "Salvando novo background! Aguarde...";
        that.loading.active = true;
        axios.post(
          `https://www.leverosintegra.com.br/map/Api/SolarBanners?token=${that.token}&background=true`,
          { image: reader.result }
        ).then(res => {
          that.loading.active = false;
          if (res && res.status === 200) {
            that.successError.title = "Sucesso!";
            that.successError.message = "Background salvo com sucesso!";
            that.successError.action = () => { window.location.reload() }
            that.successError.active = true;
          }
        }).catch(err => {
          that.loading.active = false;
          that.successError.title = "Ops...";
          that.successError.message = "Erro ao salvar background!<br/>" + err;
          that.successError.action = () => { window.location.reload() }
          that.successError.active = true;
        })
      };
      reader.onerror = function (error) {
        console.log('Error: ', error);
      };
    },

    handleActiveBackground(background) {
      this.confirm.title = "Atenção!";
      this.confirm.message = "Deseja prosseguir com a ativação do Background?<br/>O Background ativo no momento será inativado.";
      this.confirm.action = () => { this.activeBackground(background) }
      this.confirm.active = true;
    },

    activeBackground(background) {
      this.confirm.active = false;

      this.loading.message = "Ativando background! Aguarde...";
      this.loading.active = true;
      axios.post(
        `https://www.leverosintegra.com.br/map/Api/SolarBanners?token=${this.token}&activeBackground=true`,
        { id: background }
      ).then(res => {
        if (res && res.status === 200) {
          this.successError.title = "Sucesso!";
          this.successError.message = "Background ativado com sucesso!";
          this.successError.action = () => { window.location.reload() }
          this.successError.active = true;
        }
        this.loading.active = false;
      }).catch(err => {
        this.loading.active = false;
        this.successError.title = "Ops...";
        this.successError.message = "Erro ao ativar o background!<br/>" + err;
        this.successError.action = () => { window.location.reload() }
        this.successError.active = true;
        this.loading.active = false;
      })
    },

    handleDeleteBackground(background) {
      this.confirm.title = "Atenção!";
      this.confirm.message = "Deseja prosseguir com a exclusão do Background?";
      this.confirm.action = () => { this.deleteBackground(background) }
      this.confirm.active = true;
    },

    deleteBackground(background) {
      this.confirm.active = false;
      
      this.loading.message = "Deletando background! Aguarde...";
      this.loading.active = true;
      axios.post(
        `https://www.leverosintegra.com.br/map/Api/SolarBanners?token=${this.token}&background=true&deleteBackground=true`,
        { id: background }
      ).then(res => {
        if (res && res.status === 200) {
          this.successError.title = "Sucesso!";
          this.successError.message = "Background deletado com sucesso!";
          this.successError.action = () => { window.location.reload() }
          this.successError.active = true;

          this.loading.active = false;
        }
      }).catch(err => {
        this.loading.active = false;
        this.successError.title = "Ops...";
        this.successError.message = "Erro ao deletar o background!<br/>" + err;
        this.successError.action = () => { window.location.reload() }
        this.successError.active = true;
      })
    },
  }
};
</script>

<style lang="scss" scoped>
.v-tooltip__content {
  opacity: 2!important;
  background: gray;
}
.documents {
  .container {
    max-width: 90%;
    margin: 0 auto;

    .header {
      display: flex;
      margin: 20px 0;

      button {
        background: var(--standardGreen);
        color: var(--white);
        border-radius: 5px;
        padding: 10px;
        width: 40%;
      }

      input {
        border-bottom: 1px solid var(--gray-500);
        outline: none;
        margin-left: 20px;
        color: var(--gray-500);
        width: 100%;
      }
    }

    .loader {
      display: flex;
      align-items: center;
      justify-content: center;
      margin-top: 80px;

      i {
        color: var(--blue);
        font-size: 4rem;
      }
    }

    .table {
      table {
        width: 100%;
        border-collapse: collapse;
        border-spacing: 0;

        thead {
          tr {
            th {
              background: var(--gray-70);
              padding: 5px;
            }
          }
        }

        tbody {
          tr {
            td {
              padding: 10px;
              border-bottom: 1px solid var(--gray-100);
              text-align: center;

              button {
                background: var(--gray-100);
                color: var(--gray-800);
                border-radius: 10px;
                padding: 5px;
                outline: none;
              }

              a {
                color: var(--darkGreen);
              }
            }
          }
        }
      }
    }
  }
}
</style>